import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IAudioBridgeDAO, IAudioBridgeRequestParams } from '../audio-bridge.dao';
import { IAudioBridgeResponse } from '../connections.dao';
import { AUDIO_BRIDGE_URL } from '../../constants/api/zoom-api.constants';

class AudioBridgeDAO extends IAudioBridgeDAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient,
    ) {
        super();
    }

    public async getAudioBridgeDetails(params: IAudioBridgeRequestParams): Promise<IAudioBridgeResponse> {
        const response = await this.apiClient.get<IAudioBridgeResponse>(AUDIO_BRIDGE_URL, params);
        return response.parsedResponse;
    }
}

export { AudioBridgeDAO };